import type { InvoiceProcessStatus } from "../models/InvoiceStatusModel";
import {
  InvoiceAssessmentRoute,
  InvoicesListRoute,
  InvoiceValidationRoute,
} from "./routes";

export const onClickGoToInvoice = (
  invoiceId: string,
  status: InvoiceProcessStatus,
  clientIdentifier: string,
  navigate: (
    path: string,
    options?: { replace?: boolean; state?: any },
  ) => void,
  location: { pathname: string; search: string; state?: any },
) => {
  navigate(location.pathname + location.search, {
    replace: true,
    state: { ...location.state, expandedClientId: clientIdentifier },
  });
  if (status === "VALIDATION") {
    navigate(`/invoices/validate/${invoiceId}/${clientIdentifier}`, {
      state: { from: InvoiceValidationRoute.id },
    });
  } else if (status === "ASSESSMENT") {
    navigate(`/invoices/assess/${clientIdentifier}/${invoiceId}`, {
      state: {
        from: InvoiceAssessmentRoute.id,
      },
    });
  } else {
    navigate(`/invoices/overview/${invoiceId}/${clientIdentifier}`, {
      state: {
        from: InvoicesListRoute.id,
      },
    });
  }
};
